export const API_URLS = {
	ACTIVITIES: {
		GET_ALL: "/activity",
		MARK_READ: "/activity/markasread",
		MUTE: "/persona/mutedactivities",
		UPDATE_SETTINGS: "/persona/update/notificationsettings"
	}
};
